import { render, staticRenderFns } from "./EditDocument.vue?vue&type=template&id=1402a598&"
import script from "./EditDocument.vue?vue&type=script&lang=js&"
export * from "./EditDocument.vue?vue&type=script&lang=js&"
import style0 from "./EditDocument.vue?vue&type=style&index=0&id=1402a598&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports